import React, { useState } from "react";
import { API_URL } from "../../constants/appConfig";
import { toast } from "react-toastify";
import {
  Box,
  Container,
  Typography,
  Paper,
  Button,
  CircularProgress,
  Alert,
} from "@mui/material";
import {
  Backup as BackupIcon,
  CloudDone as CloudDoneIcon,
} from "@mui/icons-material";

const Index = () => {
  const [loading, setLoading] = useState(false);
  const [lastBackupTime, setLastBackupTime] = useState(null);

  const getBackup = async () => {
    setLoading(true);
    try {
      const API = API_URL + "/backup/SynchBackup";
      const response = await fetch(API);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      await response.text();
      toast.success("Yedekleme işlemi başarılı.");
      setLastBackupTime(new Date().toLocaleString('tr-TR'));
    } catch (error) {
      console.log("Hata:", error);
      toast.error("Yedekleme işlemi başarısız!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 600, color: 'primary.main', mb: 1 }}>
          Sistem Yedekleme
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Veritabanı yedekleme işlemlerini buradan yönetebilirsiniz
        </Typography>
      </Box>

      <Paper
        elevation={3}
        sx={{
          p: 4,
          borderRadius: 3,
          bgcolor: 'background.paper',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        <Box 
          sx={{ 
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            gap: 4
          }}
        >
          <Box 
            sx={{ 
              flex: 1,
              width: '100%',
              textAlign: { xs: 'center', md: 'left' }
            }}
          >
            <Typography variant="h5" gutterBottom>
              Veritabanı Yedekleme
            </Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              Tüm veritabanını yedeklemek için butona tıklayın. Bu işlem birkaç dakika sürebilir.
            </Typography>
            
            {lastBackupTime && (
              <Alert 
                severity="success" 
                icon={<CloudDoneIcon />}
                sx={{ mb: 2 }}
              >
                Son yedekleme: {lastBackupTime}
              </Alert>
            )}

            <Button
              variant="contained"
              size="large"
              disabled={loading}
              onClick={getBackup}
              startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <BackupIcon />}
              sx={{
                py: 2,
                px: 4,
                fontSize: '1.1rem',
                textTransform: 'none',
                minWidth: 200,
                position: 'relative',
                bgcolor: 'primary.main',
                '&:hover': {
                  bgcolor: 'primary.dark',
                  transform: 'translateY(-2px)',
                  boxShadow: 4
                },
                transition: 'all 0.3s ease'
              }}
            >
              {loading ? 'Yedekleniyor...' : 'Yedekle'}
            </Button>
          </Box>

          <Box 
            sx={{ 
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              p: 3,
              bgcolor: 'primary.lighter',
              borderRadius: 2,
              minWidth: 280,
              aspectRatio: '1',
              position: 'relative',
              overflow: 'hidden',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: `linear-gradient(45deg, 
                  ${theme => theme.palette.primary.lighter} 0%, 
                  ${theme => theme.palette.primary.light} 100%)`,
                opacity: 0.6
              }
            }}
          >
            <BackupIcon 
              sx={{ 
                fontSize: 120,
                color: 'primary.main',
                position: 'relative',
                zIndex: 1
              }} 
            />
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default Index;
